export default __webpack_public_path__ + "static/media/SEC1580.34I-39290_-25438_0.ef8ab508.jpg";